import React, { useEffect, useState } from 'react'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  useErrorService,
  surveyType,
  PrintableArea,
  buildQuarterAssessmentFileBase,
  formatQuarterFileLabel,
} from '@abroad/components'
import {
  useGroupName,
  WisdomAssessmentResult,
  ProsperityAssessmentResult,
  AwarenessAssessmentResult,
} from '../components'
import API from '../utils/API'

const TeamDateRangeAssessmentResult = () => {
  let { search } = useLocation()
  const { teamId } = useParams()
  let history = useHistory()
  const Error = useErrorService()
  const [survey, setSurvey] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const query = new URLSearchParams(search)
  const year = query.get('year')
  const quarter = query.get('quarter')
  const startDate = query.get('startDate')
  const endDate = query.get('endDate')
  const querySurveyType = query.get('surveyType')
  const teamName = useGroupName(teamId)
  const pdfFileNameBase =
    quarter && year
      ? buildQuarterAssessmentFileBase(
          teamName || 'Group',
          formatQuarterFileLabel(quarter, year),
          querySurveyType,
        )
      : undefined

  useEffect(() => {
    const getTeamSurveyByTeam = async () => {
      try {
        const { data } = await API.AdminAPI.teams.getSurveyDateByTeam(
          teamId,
          search,
        )
        setSurvey(data)
        setIsLoading(false)
      } catch (e) {
        if (
          e?.code === 'ValidationError' ||
          e?.code === 'resource_not_found' ||
          e?.code === 'not_found'
        ) {
          history.replace('/404')
        } else {
          setIsLoading(false)
          Error.showError(e)
        }
      }
    }
    if (((year && quarter) || (startDate && endDate)) && teamId) {
      getTeamSurveyByTeam()
    } else {
      history.replace('/admin/home')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>{`${
          teamName ? teamName : 'Group'
        } Assessment Result | Abroad`}</title>
        <meta
          name='title'
          content={`${
            teamName ? teamName : 'Group'
          } Assessment Result | Abroad`}></meta>
        <meta
          property='og:title'
          content={`${
            teamName ? teamName : 'Group'
          } Assessment Result | Abroad`}></meta>
        <meta
          property='twitter:title'
          content={`${
            teamName ? teamName : 'Group'
          } Assessment Result | Abroad`}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/admin/groups`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/groups`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/groups`}></meta>
      </Helmet>
      <main>
        {querySurveyType === surveyType.WISDOM ? (
          <WisdomAssessmentResult
            survey={survey?.wisdom}
            isLoading={isLoading}
            headerText='Group Wisdom Assessment'
            subHeaderText='GROUPS COMBINED RESULTS'
            subHeaderDescription='Below are the aggregate results for how your Group rated your organization and themselves during the specified time period.'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : querySurveyType === surveyType.PROSPERITY ? (
          <ProsperityAssessmentResult
            survey={survey?.prosperity}
            isLoading={isLoading}
            headerText='Group True Prosperity Assessment'
            subHeaderText='GROUPS COMBINED RESULTS'
            subHeaderDescription='Below are the aggregate results for how your Group rated your organization and themselves during the specified time period.'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : (
          <AwarenessAssessmentResult
            survey={survey?.awareness}
            isLoading={isLoading}
            headerText='Group Awareness Assessment'
            subHeaderText='GROUPS COMBINED RESULTS'
            subHeaderDescription='Below are the aggregate results for how your Group rated your organization and themselves during the specified time period.'
            pdfFileNameBase={pdfFileNameBase}
          />
        )}
      </main>
      <PrintableArea printSelector='main' />
    </>
  )
}

export default TeamDateRangeAssessmentResult
